import LegalNotices from '../containers/LegalNotices';
export default LegalNotices;
